import * as React from 'react';
import CustomTable from '../../table/customTable';
import { Button } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';

export default function RTKStationsTable({ data, loading }) {
  const columns_rtk_stations = [
    {
      field: 'id',
      width: 70,
      type: "number",
      headerAlign: 'center',
      hide: true,
      renderHeader: () => <strong>{'ID'}</strong>,
    },
    {
      field: 'station_name',
      width: 180,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => <b>{params.row.station_name}</b>,
      renderHeader: () => <strong>{'Station Name'}</strong>,
    },
    {
      field: 'port',
      headerName: 'Port',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      renderCell: (params) => <span>{params.row.port || '-'}</span>,
      renderHeader: () => <strong>{'Port'}</strong>,
    },
    {
      field: 'status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      width: 120,
      renderCell: (params) => {
        const status = params.row.status || 'unknown';
        const statusColors = {
          'active': '#4caf50',
          'inactive': '#f44336',
          'error': '#ff9800',
          'unknown': '#9e9e9e'
        };
        return (
          <span style={{ 
            color: statusColors[status.toLowerCase()] || statusColors.unknown,
            fontWeight: 'bold'
          }}>
            {status.toUpperCase()}
          </span>
        );
      },
      renderHeader: () => <strong>{'Status'}</strong>,
    },
    {
      field: 'coordinates',
      headerName: 'Coordinates',
      headerAlign: 'center',
      align: 'center',
      width: 200,
      renderCell: (params) => {
        const coords = params.row.coordinates;
        if (coords && coords.lat && coords.lon) {
          return (
            <span>
              {coords.lat.toFixed(6)}, {coords.lon.toFixed(6)}
              {coords.alt && ` (${coords.alt.toFixed(2)}m)`}
            </span>
          );
        }
        return <span>-</span>;
      },
      renderHeader: () => <strong>{'Coordinates'}</strong>,
    },
    {
      field: 'sw_version',
      headerName: 'SW Version',
      headerAlign: 'center',
      align: 'center',
      width: 140,
      renderCell: (params) => params.row.sw_version || '-',
      renderHeader: () => <strong>{'SW Version'}</strong>,
    },
    {
      field: 'ublox_version',
      headerName: 'Ublox Version',
      headerAlign: 'center',
      align: 'center',
      width: 140,
      renderCell: (params) => params.row.ublox_version || '-',
      renderHeader: () => <strong>{'Ublox Version'}</strong>,
    },
    {
      field: 'configure',
      headerAlign: 'center',
      sortable: false,
      width: 150,
      align: 'center',
      renderHeader: () => <strong>{'Configuration'}</strong>,
      renderCell: (params) => {
        const { row } = params;
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<SettingsIcon />}
            onClick={(e) => {
              e.stopPropagation();
              row.configure(row);
            }}
          >
            Configure
          </Button>
        );
      },
    },
    {
      field: 'delete',
      headerAlign: 'center',
      sortable: false,
      width: 150,
      align: 'center',
      renderHeader: () => <strong>{'Delete'}</strong>,
      renderCell: (params) => {
        const { row } = params;
        // Only show delete button for registered stations
        if (!row.is_registered) {
          return null;
        }
        return (
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<DeleteIcon />}
            onClick={(e) => {
              e.stopPropagation();
              if (row.delete) {
                row.delete(row);
              }
            }}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  return (
    <CustomTable
      data={data}
      columns={columns_rtk_stations}
      sortModel={null}
      onSortModelChange={null}
      tableActions={null}
    />
  );
}